export interface NotificationsSettings {
  id: string;
  user_uuid: string;
  hospital_uuid: string;
  notification_channel: 'NOTIFICATION_CHANNEL_TEXT' | string;
  notification_type: 'CHAT_MESSAGE_NEW' | 'MEMBER_NOTIFICATION_EVENT' | string;
  enabled: boolean;
  enabled_in_external_system: boolean;
  notifications_caller_id: string;
}

export interface GetNotificationsSettingsListParams {
  memberUuid?: string;
  hospitalUuid?: string;
  pageIndex: number;
  pageSize: number;
}

export interface CreateNotificationsSettingsPayload {
  hospital_uuid: string;
  notification_type?: string;
  notification_channel?: string;
  enabled: boolean;
}

export type UpdateNotificationsSettingsPayload = CreateNotificationsSettingsPayload;

export interface UpdateNotificationsPreferencesPayload {
  notification_type?: string;
  notification_channel?: string;
  enabled: boolean;
}

export enum NotificationType {
  CHAT_MESSAGE_NEW = 'CHAT_MESSAGE_NEW',
  MEMBER_NOTIFICATION_EVENT = 'MEMBER_NOTIFICATION_EVENT',
}

export enum NotificationChannel {
  NOTIFICATION_CHANNEL_TEXT = 'NOTIFICATION_CHANNEL_TEXT',
}
